import script from "./WageExcelUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageExcelUp.vue?vue&type=script&setup=true&lang=ts"

import "./WageExcelUp.vue?vue&type=style&index=0&id=0a263218&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a263218"]])

export default __exports__